module.exports = __webpack_public_path__ + "static/media/levitate-home.213c0a9e.png";